import { defineStore } from 'pinia';
import api from '@/services/api';

export const useTextoPredeterminadoStore = defineStore('textoPredeterminadoStore', {
  state: () => ({
    textoPredeterminadoList: [],
    page: 1,
  }),
  actions: {
    async findAllTextoPredeterminadoHTTP() {
      const result = await api.get('/texto-predeterminado', {
        params: { page: +this.page, sortBy: 'Codigo', sort: 'asc', Activo: true },
      });
      if (result && result.data) {
        this.textoPredeterminadoList.splice(0, this.textoPredeterminadoList.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },

    async firstTextoPredeterminado() {
      this.setPage(1);
      this.emptyList();
      await this.findAllTextoPredeterminadoHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.textoPredeterminadoList = [];
    },
  },
});
